import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';
import FuseTheme from '../global/theme';
import IconButton from 'material-ui/IconButton';
import ContentCreate from 'material-ui/svg-icons/content/create';
import ContentDelete from 'material-ui/svg-icons/action/delete';
import ContentView from 'material-ui/svg-icons/image/remove-red-eye';

/**
 * Adds inline content for default units
 *
 * @param data
 * @return {string}
 */
const isDefault = (data) => {
    if (data.default_unit && data.default_unit === true) {
        return ' (Default)'
    }
    return ''
};

/**
 * Display Default Price if it exists
 * @param data
 * @return {*}
 */
const showPrice = (data) => {
    if (data.price && data.price.default) {
        return data.price.default
    }
    return '(none)'
};

const styles = {
    row: {height: '38px',},
    column: {height: '38px', paddingLeft: '20px', paddingRight: '20px'},
    columnFirst: {paddingLeft: '36px'},
    columnWrap: {textOverflow: 'initial', whiteSpace: 'normal'},
    icon: {height: '32px', padding: '4px', overflow: 'inherit'}
};

const ProductUnitStaticTableRow = ({data, productUnitPath, showDelete = false, showEdit = false, showView = false}) => (
    <TableRow style={styles.row}>
        <TableRowColumn style={{...styles.column, ...styles.columnFirst}}>
            {data.id}
        </TableRowColumn>
        <TableRowColumn style={{...styles.column, ...styles.columnWrap}}>
            {data.name}
        </TableRowColumn>
        <TableRowColumn style={styles.column}>
            {data.unit_type}{isDefault(data)}
        </TableRowColumn>
        <TableRowColumn style={styles.column}>
            {showPrice(data)}
        </TableRowColumn>

        {showView &&
        <TableRowColumn style={styles.column}>
            <IconButton
                containerElement={<Link to={`${productUnitPath}/${encodeURIComponent(data.type)}/${data.id}/show`}/>}
                style={styles.icon}>
                <ContentView color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
        {showEdit &&
        <TableRowColumn style={styles.column}>
            <IconButton
                containerElement={<Link to={`${productUnitPath}/${encodeURIComponent(data.type)}/${data.id}`}/>}
                style={styles.icon}>
                <ContentCreate color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
        {showDelete &&
        <TableRowColumn style={styles.column}>
            <IconButton
                containerElement={<Link to={`${productUnitPath}/${encodeURIComponent(data.type)}/${data.id}/delete`}/>}
                style={styles.icon}>
                <ContentDelete color={FuseTheme.palette.primary1Color}/>
            </IconButton>
        </TableRowColumn>
        }
    </TableRow>
);

ProductUnitStaticTableRow.propTypes = {
    data: PropTypes.object.isRequired,
    productUnitPath: PropTypes.string,
    showDelete: PropTypes.bool,
    showEdit: PropTypes.bool,
    showView: PropTypes.bool,
};

ProductUnitStaticTableRow.defaultProps = {
    productUnitPath: '/ProductUnits',
    style: {padding: 0},
};

export default ProductUnitStaticTableRow;



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitStaticTableRow.js